module.exports = __webpack_public_path__ + "static/media/Copia de info.d22f7244.svg";